import React from 'react';

import { SearchContext } from 'src/providers/SearchProvider';

export function useSearch() {
  return React.use(SearchContext);
}
